import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-chips',
  templateUrl: './chips.component.html',
  styleUrls: ['./chips.component.css']
})
export class ChipsComponent {
  @Input() active: string = '';
  @Output() choose = new EventEmitter<string>();

  variants = ['Proxy', 'Droped', 'Direct'];

  handleChoose(variant: string): void {
    this.choose.emit(variant);
  }
} 